export function ensureOriginInString(url: string, newOrigin: string): string {
    const urlObj = new URL(url, newOrigin);
    if (urlObj.origin !== newOrigin) {
        urlObj.host = new URL(newOrigin).host;
    }
    return urlObj.toString();
}

export function ensureOriginInRequest(request: Request, newOrigin: string): Request {
    return {
        ...request,
        url: ensureOriginInString(request.url, newOrigin),
    };
}
